const moment = require('moment');

export default prettyDate;

function prettyDate(date) {
    if (!date) return "";
    return moment(date).format('MMMM Do YYYY, h:mm A');
}
